export const productsTableContainerStyle = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  // Allow this flex child to shrink below its content height so the inner
  // content region (not the window) owns the scroll. Without this the page
  // grows past the viewport and a second "big" scrollbar appears.
  minHeight: 0,
};

export const productsHeaderStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: "24px",
  flexWrap: "wrap",
  gap: "12px",
};

export const productsHeaderLeftStyle = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
};

export const myProductsTitleStyle = {
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: "24px",
  color: "#2F2B3D",
};

export const addProductButtonStyle = {
  backgroundColor: "#248B70",
  color: "#fff",
  textTransform: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 500,
  px: "16px",
  py: "8px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#1f7b63",
    boxShadow: "none",
  },
};

export const searchFieldStyle = {
  width: { xs: "100%", sm: "220px" },
  "& .MuiOutlinedInput-root": {
    height: "39px",
    fontWeight: 400,
    fontSize: "14px",
    color: "rgba(62, 63, 76, 0.7)",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    paddingLeft: "12px",
    "& input": {
      paddingY: "10px",
    },
    "& fieldset": {
      borderWidth: "1px",
      borderColor: "#EAEAEA",
    },
    "&:hover fieldset": {
      borderWidth: "1px",
      borderColor: "#3e3f4c",
    },
    "&.Mui-focused fieldset": {
      borderWidth: "1px",
      borderColor: "#3e3f4c",
    },
  },
};

export const productsTableStyle = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: 0,
  "& thead": {
    "& th": {
      fontSize: "13px",
      fontWeight: 600,
      color: "rgba(72, 72, 72, 0.7)",
      borderBottom: "1px solid #EAEAEA",
      padding: "12px 16px",
      textAlign: "left",
      whiteSpace: "nowrap",
    },
  },
  "& tbody": {
    "& tr": {
      cursor: "default",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.02)",
      },
    },
    "& td": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#2F2B3D",
      borderBottom: "1px solid #F5F5F5",
      padding: "12px 16px",
      verticalAlign: "middle",
    },
  },
};

export const productNameCellStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

export const productThumbnailStyle = {
  width: "36px",
  height: "36px",
  borderRadius: "6px",
  objectFit: "cover",
};

export const pausedBadgeStyle = {
  display: "inline-block",
  backgroundColor: "#FFF3E0",
  color: "#E65100",
  fontSize: "11px",
  fontWeight: 600,
  borderRadius: "4px",
  padding: "2px 8px",
  marginLeft: "8px",
};

export const kebabMenuStyle = {
  "& .MuiPaper-root": {
    borderRadius: "8px",
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.12)",
    minWidth: "160px",
  },
  "& .MuiMenuItem-root": {
    fontSize: "14px",
    fontWeight: 400,
    color: "#2F2B3D",
    px: "16px",
    py: "10px",
    "&:hover": {
      backgroundColor: "rgba(36, 139, 112, 0.08)",
    },
  },
};

export const emptyStateBoxStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  minHeight: "300px",
  border: "1px solid #EAEAEA",
  borderRadius: "12px",
  py: "48px",
};

export const emptyStateIconStyle = {
  width: "48px",
  height: "48px",
  mb: "16px",
  opacity: 0.6,
};

export const emptyStateTitleStyle = {
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "28px",
  color: "rgba(72, 72, 72, 0.9)",
};

export const emptyStateDescriptionStyle = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  mt: "6px",
  color: "rgba(72, 72, 72, 0.7)",
  textAlign: "center",
  maxWidth: "350px",
};

// Add/Edit Product Modal styles
export const productModalPaperStyle = {
  borderRadius: "16px",
  maxWidth: "1200px",
  width: "100%",
  maxHeight: "90vh",
  m: { xs: "16px", sm: "32px" },
};

export const productModalHeaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #EAEAEA",
  px: "24px",
  py: "16px",
};

export const productModalTitleStyle = {
  fontWeight: 600,
  fontSize: "18px",
  color: "#2F2B3DE5",
};

export const productModalHeaderIconsStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const productModalContentStyle = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: "24px",
  p: "24px",
  overflowY: "auto",
};

export const productModalFieldLabel = {
  fontSize: "14px",
  fontWeight: 500,
  color: "#2F2B3DE5",
  mb: "6px",
};

export const productModalTextField = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "14px",
    "& fieldset": {
      borderColor: "#EAEAEA",
    },
    "&:hover fieldset": {
      borderColor: "#46a091",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#46a091",
    },
  },
};

export const productModalTextFieldError = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "14px",
    "& fieldset": {
      borderColor: "#d32f2f",
    },
    "&:hover fieldset": {
      borderColor: "#d32f2f",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#d32f2f",
    },
  },
};

export const productModalFooterStyle = {
  borderTop: "1px solid #EAEAEA",
  px: { xs: "16px", sm: "24px" },
  py: "16px",
};

export const productModalFooterRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
};

export const backWithoutSavingBtnStyle = {
  backgroundColor: "#6C727F",
  color: "#fff",
  fontSize: { xs: "13px", sm: "14px" },
  borderRadius: "10px",
  px: { xs: "14px", sm: "20px" },
  whiteSpace: "nowrap",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": { backgroundColor: "#5b5f6b", boxShadow: "none" },
};

export const createProductBtnStyle = {
  backgroundColor: "#248B70",
  color: "#fff",
  borderRadius: "10px",
  fontSize: { xs: "13px", sm: "14px" },
  px: { xs: "16px", sm: "24px" },
  whiteSpace: "nowrap",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": { backgroundColor: "#1f7b63", boxShadow: "none" },
  "&:disabled": { backgroundColor: "#e0e0e0" },
};

// Secondary action beside the primary one (e.g. "Save draft" next to
// "Publish"): the same shape as createProductBtnStyle, outlined in the brand
// green so the filled button stays the obvious next step.
export const secondaryProductBtnStyle = {
  ...createProductBtnStyle,
  backgroundColor: "transparent",
  color: "#248B70",
  border: "1px solid #248B70",
  "&:hover": {
    backgroundColor: "rgba(36, 139, 112, 0.04)",
    boxShadow: "none",
  },
  "&:disabled": { color: "rgba(36, 139, 112, 0.4)", borderColor: "rgba(36, 139, 112, 0.4)" },
};

// The primary/secondary pair on the end side of the footer row.
export const productModalPrimaryActionsStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
  justifyContent: "flex-end",
};

// An inline text action in the brand green ("Add a photo to publish", "Use as
// main photo"). A real <button>, reset to look like the cant-find link.
export const textActionButtonStyle = {
  border: "none",
  background: "none",
  p: 0,
  font: "inherit",
  fontSize: "13px",
  fontWeight: 500,
  color: "#248B70",
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlineOffset: "2px",
  textAlign: "start",
  "&:hover": { color: "#1f7b63" },
  "&:focus-visible": {
    outline: "2px solid #248B70",
    outlineOffset: "2px",
    borderRadius: "2px",
  },
};

// The hint under the main image when the item will be saved as a draft.
export const draftHintStyle = {
  fontSize: "12px",
  lineHeight: "18px",
  color: "rgba(72, 72, 72, 0.7)",
  mt: "6px",
};

// The "N drafts aren't published yet" line and its "Show drafts only" chip,
// under the catalog header. Wraps on narrow screens.
export const draftFilterRowStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "8px 12px",
  mt: "-12px",
  mb: "16px",
};

export const draftCountLineStyle = {
  fontSize: "14px",
  lineHeight: "20px",
  color: "rgba(72, 72, 72, 0.7)",
};

// The drafts filter toggle: outlined brand green, filled pale green when on.
export const draftFilterChipStyle = (selected) => ({
  height: "28px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#248B70",
  border: "1px solid #248B70",
  backgroundColor: selected ? "#E1F0ED" : "transparent",
  "&&:hover": { backgroundColor: selected ? "#D2E9E3" : "rgba(36, 139, 112, 0.04)" },
  "& .MuiChip-deleteIcon": {
    color: "#248B70",
    "&:hover": { color: "#1f7b63" },
  },
});

export const cantFindLinkStyle = {
  fontSize: "14px",
  color: "rgba(72, 72, 72, 0.7)",
  textAlign: "center",
  "& a": {
    color: "#248B70",
    fontWeight: 500,
    cursor: "pointer",
    textDecoration: "underline",
    whiteSpace: "nowrap",
  },
};

// Shown on its own line above the buttons on mobile, inline between them on larger screens
export const cantFindLinkMobileStyle = {
  ...cantFindLinkStyle,
  display: { xs: "block", sm: "none" },
  mb: "12px",
};

export const cantFindLinkDesktopStyle = {
  ...cantFindLinkStyle,
  display: { xs: "none", sm: "block" },
};

// Image upload grid
export const imageUploadGridStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
};

export const imageUploadItemStyle = {
  position: "relative",
  width: "80px",
  height: "80px",
  borderRadius: "8px",
  overflow: "hidden",
  border: "1px solid #EAEAEA",
};

export const imageUploadRemoveStyle = {
  position: "absolute",
  top: "2px",
  right: "2px",
  width: "18px",
  height: "18px",
  backgroundColor: "rgba(0,0,0,0.5)",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  zIndex: 1,
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.7)",
  },
};

export const imageUploadAddBtnStyle = {
  width: "80px",
  height: "80px",
  borderRadius: "8px",
  border: "1px dashed #BDBDBD",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  gap: "4px",
  "&:hover": {
    borderColor: "#248B70",
    backgroundColor: "rgba(36, 139, 112, 0.04)",
  },
};

// Missing category modal
export const missingCategoryPaperStyle = {
  borderRadius: "16px",
  maxWidth: "500px",
  width: "100%",
  m: { xs: "16px", sm: "32px" },
};

// Category dropdown
export const categoryDropdownStyle = {
  borderRadius: "8px",
  fontSize: "14px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#EAEAEA",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#46a091",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#46a091",
  },
};

// Category dropdown menu. MUI's Select overlays the menu on top of the field by
// default (native-select behaviour), which with the long catalog category tree
// throws the list across the whole viewport — so anchor it BELOW the input with
// a capped, scrollable height. Direction-aware: MUI does not flip anchorOrigin
// for theme direction, so in RTL (Hebrew) the menu hangs from the input's right
// edge and grows leftward.
export const getCategoryMenuProps = (isRtl) => ({
  anchorOrigin: { vertical: "bottom", horizontal: isRtl ? "right" : "left" },
  transformOrigin: { vertical: "top", horizontal: isRtl ? "right" : "left" },
  PaperProps: {
    sx: {
      maxHeight: 320,
      mt: "4px",
      "& .MuiMenuItem-root.Mui-selected": {
        backgroundColor: "#E1F0ED",
        "&:hover": {
          backgroundColor: "#E1F0ED",
        },
      },
      "& .MuiMenuItem-root:hover": {
        backgroundColor: "#F5F5F5",
      },
      "& .MuiMenuItem-root:focus": {
        backgroundColor: "#E1F0ED",
        outline: "none",
      },
      "& .MuiMenuItem-root.Mui-focusVisible": {
        backgroundColor: "#E1F0ED",
        outline: "none",
      },
    },
  },
});

// Tooltip icon
export const tooltipIconStyle = {
  width: "16px",
  height: "16px",
  color: "rgba(72, 72, 72, 0.5)",
  cursor: "pointer",
  ml: "4px",
};

// Delete dialog
export const deleteDialogPaperStyle = {
  borderRadius: "16px",
  maxWidth: "440px",
  width: "100%",
  p: "24px",
};

export const deleteDialogTitleStyle = {
  fontWeight: 600,
  fontSize: "18px",
  color: "#2F2B3DE5",
  mb: "8px",
};

export const deleteDialogDescStyle = {
  fontSize: "14px",
  color: "rgba(72, 72, 72, 0.7)",
  mb: "24px",
};

export const deleteDialogActionsStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
};
